import { flexRender } from "@tanstack/react-table";
import { Table } from "../../TableV2";

export const HeaderText = ({ header }: { header: any }) => (
  <Table.TableHeaderText className={header.column.columnDef.thInnerClassName}>
    {flexRender(header.column.columnDef.header, header.getContext())}
  </Table.TableHeaderText>
);
